import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useFeedback } from '../context/FeedbackContext';
import { useHelp } from '../context/HelpContext';
import ContentReader from './ContentReader';
import AboutModal from './AboutModal';
import styles from '../styles/footer.module.css';

const Footer: React.FC = () => {
  const { openFeedbackModal } = useFeedback();
  const { openHelp } = useHelp();
  const location = useLocation();
  
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [version, setVersion] = useState('1.0.0');
  
  // Load version from version-info.json (always fetch fresh, never from cache)
  useEffect(() => {
    fetch('/version-info.json', { cache: 'no-store' })
      .then(res => res.json())
      .then(data => setVersion(data.version))
      .catch(() => setVersion('1.0.0')); // fallback
  }, []);

  const getPageIdentifier = () => {
    const path = location.pathname;
    if (path.includes('/step-')) {
      const stepMatch = path.match(/\/step-(\d+)/);
      return stepMatch ? `Step ${stepMatch[1]}` : path;
    }
    if (path === '/') return 'Home';
    if (path === '/saa') return 'SAA Home';
    if (path === '/saa/12-steps') return '12 Steps';
    if (path === '/dashboard') return 'Dashboard';
    if (path === '/discover') return 'Discover';
    if (path === '/self-assess') return 'Self Assessment';
    if (path === '/admin') return 'Admin';
    if (path === '/onboarding') return 'Onboarding';
    return path.replace('/', '').replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  };

  const handleFeedbackClick = () => {
    openFeedbackModal(getPageIdentifier());
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        {/* Main Footer Sections */}
        <div className={styles.footerSections}>
          {/* Recovery Resources */}
          <div className={styles.footerSection}>
            <h4>Recovery Resources</h4>
            <ul>
              <li><Link to="/discover">Recovery Programs</Link></li>
              <li><Link to="/self-assess">Self Assessment</Link></li>
              <li><Link to="/">Home</Link></li>
            </ul>
          </div>

          {/* Support & Help */}
          <div className={styles.footerSection}>
            <h4>Support & Help</h4>
            <ul>
              <li><button onClick={() => openHelp(undefined, 'browse')} className={styles.footerLink}>Help & Tour</button></li>
              <li><button onClick={handleFeedbackClick} className={styles.footerLink}>Feedback</button></li>
              <li><button onClick={() => setIsAboutOpen(true)} className={styles.footerLink}>About</button></li>
              <li><button onClick={() => setIsPrivacyOpen(true)} className={styles.footerLink}>Privacy Policy</button></li>
            </ul>
          </div>

          {/* Legal & Info */}
          <div className={styles.footerSection}>
            <h4>Legal & Info</h4>
            <ul>
              <li><span className={styles.versionInfo}>Version {version}</span></li>
              <li><span className={styles.copyright}>© 2025 Recovery Commons</span></li>
              <li><span className={styles.rights}>All rights reserved</span></li>
            </ul>
          </div>
        </div>


      </div>

      {/* Modals */}
      <ContentReader
        isOpen={isPrivacyOpen}
        onClose={() => setIsPrivacyOpen(false)}
        filePath="/content/Recovery-Commons-Privacy.md"
        startTag=""
        endTag=""
        title="Your privacy matters"
      />
      
      <AboutModal
        isOpen={isAboutOpen}
        onClose={() => setIsAboutOpen(false)}
      />
    </footer>
  );
};

export default Footer;
